import { IconProps } from "../../utils/global-types/global-types";

const VerbachatIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M12.75 1.5h-7.5A3.743 3.743 0 0 0 1.5 5.235v5.235a3.743 3.743 0 0 0 3.75 3.735h1.125c.202 0 .473.135.6.3L8.1 15.997c.495.66 1.305.66 1.8 0l1.125-1.492a.76.76 0 0 1 .6-.3h1.125c2.07 0 3.75-1.672 3.75-3.735V5.235A3.743 3.743 0 0 0 12.75 1.5m-3 8.813h-4.5a.567.567 0 0 1-.562-.563c0-.307.255-.562.562-.562h4.5c.307 0 .563.255.563.562a.567.567 0 0 1-.563.563m3-3.75h-7.5A.567.567 0 0 1 4.688 6c0-.308.255-.562.562-.562h7.5c.307 0 .563.255.563.562a.567.567 0 0 1-.563.563"
      ></path>
    </svg>
  );
};

export default VerbachatIcon;
